import React, { useState } from 'react';
import { Space, Table, Button, Spin, DatePicker, Col, Row, Statistic, Card, Typography } from 'antd';
import axios from 'axios';
import moment from 'moment';
import * as XLSX from 'xlsx'; // Importação da biblioteca XLSX para exportação
import { ArrowLeftOutlined, FireOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import '../volume.css';
import { useHistory } from 'react-router-dom';

const { Title } = Typography;

function VolumeConsumido() {
  const [error, setError] = useState();
  const [lista, setLista] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]); // Armazena o intervalo de datas selecionado
  const history = useHistory();

  // Função para fazer a requisição com base no intervalo de datas
  const fetchData = (startDate, endDate) => {
    setLoading(true);

    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);
    startDateObj.setHours(0, 0, 0, 0);
    endDateObj.setHours(0, 0, 0, 0);
    axios({
      method: 'post',
      url: `${localStorage.getItem('url')}/web/volume_consumido/`,
      headers: { 
        'Authorization': `token ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json' 
      },
      data: { 
        start_date: startDate, 
        end_date: endDate 
      },
    })
      .then((response) => {
        setLoading(false);
        if (response.data && response.data.length > 0) {
          setLista(response.data);
          setData(response.data);
        } else {
          setLista([]); // Define como uma lista vazia para evitar erros
        }
      })
      .catch((e) => {
        setLoading(false);
        setError(e.message);
      });
  };

  // Função para manipular a seleção de datas
  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const startDate = dates[0];
      const endDate = dates[1];
      setSelectedDates([startDate, endDate]);
      fetchData(startDate, endDate);
    }
  };

  // Função para exportar os dados para Excel
  const exportToExcel = () => {
    const exportData = data.map((item) => ({
      Mês: item.month,
      'Total de Metros Cúbicos': item.total_metros,
      'Número de Clientes': item.numero_clientes,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Relatório');
    XLSX.writeFile(workbook, 'relatorio_volume_consumido.xlsx');
  };

  // Definindo as colunas para o resumo mensal
  const columns = [
    {
      title: 'Mês',
      dataIndex: 'month',
      key: 'month',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Total de Metros Cúbicos',
      dataIndex: 'total_metros',
      key: 'total_metros',
      render: (text) => <span>{text} m³</span>,
    },
    {
      title: 'Número de Clientes',
      dataIndex: 'numero_clientes',
      key: 'numero_clientes',
      render: (text) => <span>{text}</span>,
    },
  ];

  return (
    <div>
<Title onClick={() => { history.goBack(); }} className='volta_' level={3}>
  <ArrowLeftOutlined /> Volume Adquirido
</Title>


      {/* Solicitar a seleção das datas antes de carregar os dados */}
      <div style={{ marginBottom: 20 }}>
        <p>Por favor, selecione o intervalo de datas para visualizar os dados:</p>
        <DatePicker.RangePicker
          onChange={handleDateChange}
          format="YYYY-MM-DD"
        />
      </div>

      {loading && (
        <div className="LoadingScreen">
          <Spin tip="Carregando" size="large" />
        </div>
      )}

      {lista && lista.length > 0 && !loading && (
        <>
          <div className="totais" style={{ display: 'flex', flexDirection: 'row', marginBottom: 20 }}>
            <Col span={12}>
              <Card bordered={false}>
                <Statistic
                  title="Total Volume Consumido"
                  value={lista.reduce((total, item) => total + item.total_metros, 0)}  // Soma de todos os metros cúbicos
                  precision={2}
                  valueStyle={{ color: 'red' }}
                  prefix={<FireOutlined />}
                  suffix="m3"
                />
              </Card>
            </Col>
           {/** <Col span={12}>
              <Card bordered={false}>
                <Statistic
                  title="Número total de Clientes"
                  value={lista.reduce((total, item) => total + item.numero_clientes, 0)}  // Soma de todos os clientes
                  precision={0}
                  valueStyle={{ color: '#3f8600' }}
                  prefix={<UsergroupAddOutlined />}
                  suffix=""
                />
              </Card>
            </Col> */}
          </div>

          {/* Tabela de resumo por mês */}
          <Table
            columns={columns}
            dataSource={data}
            pagination={{ pageSize: 10 }}
            rowKey="month"
          />

          {/* Botão de exportação para Excel */}
          <Button type="primary" onClick={exportToExcel} style={{ marginTop: 20 }}>
            Exportar para Excel
          </Button>
        </>
      )}

      {lista && lista.length === 0 && !loading && (
        <p>Nenhum dado encontrado para o intervalo de datas selecionado.</p>
      )}

      {error && <p style={{ color: 'red' }}>Erro: {error}</p>}
    </div>
  );
}

export default VolumeConsumido;
